import { useLocaleState } from "react-admin";
import { faqFR } from "./faqFR";
import { faqEN } from "./faqEN";

export default function faq() {
    const [locale, setLocale] = useLocaleState();
    if (locale === "fr") return faqFR
    return faqEN

}